export default "__VITE_ASSET__CGBhcNtm__"